//
//
//
//

import { getToken } from "@utils/userStorage";
import VueUeditorWrap from "@wenwo-public/vue-ueditor-module";
export default {
  components: {
    VueUeditorWrap
  },
  props: {
    value: String,
    editable: {
      type: Boolean,
      default: true
    },
    maximumWords: {
      type: Number,
      default: 200000
    },
    initialFrameHeight: {
      type: Number,
      default: 240
    },
    zindex: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      default: ""
    },
    hasVideo: {
      type: Boolean,
      default: false
    },
    toolbars: {
      type: Array,
      default: () => [
      // "anchor", //锚点
      "undo",
      //撤销
      "redo",
      //重做
      "bold",
      //加粗
      "indent",
      //首行缩进
      // "snapscreen", //截图
      "italic",
      //斜体
      "underline",
      //下划线
      "strikethrough",
      //删除线
      "subscript",
      //下标
      "fontborder",
      //字符边框
      "superscript",
      //上标
      "formatmatch",
      //格式刷
      // "source", //源代码
      "blockquote",
      //引用
      "pasteplain",
      //纯文本粘贴模式
      "selectall",
      //全选
      // "print", //打印
      // "preview", //预览
      "horizontal",
      //分隔线
      "removeformat",
      //清除格式
      "time",
      //时间
      "date",
      //日期
      "unlink",
      //取消链接
      "insertrow",
      //前插入行
      "insertcol",
      //前插入列
      // "mergeright", //右合并单元格
      // "mergedown", //下合并单元格
      // "deleterow", //删除行
      // "deletecol", //删除列
      // "splittorows", //拆分成行
      // "splittocols", //拆分成列
      // "splittocells", //完全拆分单元格
      // "deletecaption", //删除表格标题
      "inserttitle",
      //插入标题
      // "mergecells", //合并多个单元格
      // "deletetable", //删除表格
      "cleardoc",
      //清空文档
      // "insertparagraphbeforetable", //"表格前插入行"
      // "insertcode", //代码语言
      "fontfamily",
      //字体
      "fontsize",
      //字号
      "paragraph",
      //段落格式
      "simpleupload",
      //单图上传
      // "insertimage", //多图上传
      // "edittable", //表格属性
      // "edittd", //单元格属性
      "link",
      //超链接
      "emotion",
      //表情
      "spechars",
      //特殊字符
      "searchreplace",
      //查询替换
      // "map", //Baidu地图
      // "gmap", //Google地图
      // "help", //帮助
      "justifyleft",
      //居左对齐
      "justifyright",
      //居右对齐
      "justifycenter",
      //居中对齐
      "justifyjustify",
      //两端对齐
      "forecolor",
      //字体颜色
      "backcolor",
      //背景色
      "insertorderedlist",
      //有序列表
      "insertunorderedlist",
      //无序列表
      "fullscreen",
      //全屏
      "directionalityltr",
      //从左向右输入
      "directionalityrtl",
      //从右向左输入
      "rowspacingtop",
      //段前距
      "rowspacingbottom",
      //段后距
      "pagebreak",
      //分页
      // "insertframe", //插入Iframe
      "imagenone",
      //默认
      // "imageleft", //左浮动
      // "imageright", //右浮动
      // "attachment", //附件
      "imagecenter",
      //居中
      // "wordimage", //图片转存
      "lineheight",
      //行间距
      // "edittip ", //编辑提示
      // "customstyle", //自定义标题
      "autotypeset",
      //自动排版
      // "webapp", //百度应用
      "touppercase",
      //字母大写
      "tolowercase" //字母小写
      // "background", //背景
      // "template", //模板
      // "scrawl", //涂鸦
      // "music", //音乐
      // "inserttable", //插入表格
      // "drafts", // 从草稿箱加载
      // "charts", // 图表
      ]
    }
  },
  data() {
    return {};
  },
  computed: {
    myConfig() {
      const token = getToken();
      const config = {
        imageUrlPrefix: "",
        imageMaxSize: 5 * 1024 * 1024,
        // imageFieldName: "imageName",
        // imageActionName: "uploadImage",
        imageAllowFiles: [".png", ".jpg", ".jpeg", ".gif", ".bmp"],
        // 你的UEditor资源存放的路径，相对于打包后的index.html
        UEDITOR_HOME_URL: process.env.VUE_APP_PUBLIC_PATH + "static/UEditor_1.4.3_5/",
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        imageScaleEnabled: true,
        // serverUrl: "/api/file/uploadFile",
        // serverUrl: "http://localhost:8887/uploadImage/up",
        // 初始容器高度
        initialFrameHeight: this.initialFrameHeight,
        zIndex: this.zindex || 0,
        wordCount: true,
        //是否开启字数统计
        maximumWords: this.maximumWords,
        //允许的最大字符数
        elementPathEnabled: false,
        //元素path
        // catchRemoteImageUrl: "http://wenwo-cloud-adaptor-sp-test.wenwo.cn/content/spider/wechat/uploadLink",
        // 初始容器宽度
        initialFrameWidth: "100%",
        businessSource: "biz",
        // 必填 业务端来源:{biz:企业端;business:商业端;doctor:医端;user:C端}
        sourceTerminal: "pc",
        initialStyle: "p{word-break:break-all;line-break: anywhere;}",
        //编辑器内容body容器的样式
        toolbars: [this.toolbars],
        headers: {
          Authorization: "Bearer business=" + token
        },
        token: token,
        sliceSize: 5,
        videoMaxSize: 20000,
        //单位:M
        videoAllowFiles: ["video/mp4"]
      };
      if (this.hasVideo) {
        config.toolbars[0].splice(31, 0, "insertvideo");
      }
      return config;
    },
    content: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  },
  watch: {
    value: {
      handler(val, oldVal) {
        if (!oldVal && val) {
          this.content = val;
        }
      },
      immediate: true
    },
    maximumWords: {
      handler() {
        this.myConfig.maximumWords = this.maximumWords;
      },
      immediate: true
    }
  },
  methods: {
    editorReady(editor) {
      this.UEditor = editor;
      this.$emit("ready", editor);
    },
    setContent(val) {
      this.UEditor.setContent(val);
    },
    getContent() {
      return this.UEditor.getContent();
    },
    getContentTxt() {
      return this.UEditor.getContentTxt();
    },
    hasContent() {
      return this.UEditor.getContent().length != 0;
    },
    onCatchRemoteLoading() {
      this.$emit("catch-remote-loading");
    },
    onCatchRemoteEnd() {
      this.$emit("catch-remote-end");
    }
  }
};